export default __webpack_public_path__ + "static/media/image2.1c6f7de3.png";